const styles = theme => ({
  root: { display: 'flex', width: '100%' },
  label: { fontSize: 14, marginBottom: 0 },
  // formControl: { 'margin-top': theme.spacing.unit },
  group: {
    'flex-direction': 'row',
    '-ms-flex-direction': 'row',
  },
  checked: { color: '#2974FF !important' },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/genderSwitch/GenderSwitchStyles.js